<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav">
      </p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <p-header class="ad-types-header-wrapper">
        <h2 class="ad-types-header-text">Ad Types</h2>
      </p-header>
      <p-panel class="ad-types-form-panel">
        <p-header class="ad-types-header-wrapper form-panel-header">
          <h3 class="ad-types-header-text">Vehicle Ads</h3>
          <div class="ad-types-header-input">
            <div class="ad-types-header-input">
              <p-toggleswitch [ngModel]="accountAdTypes !== null && accountAdTypes.vehicleAdType.enabled" (ngModelChange)="accountAdTypes !== null && (accountAdTypes.vehicleAdType.enabled = $event)"
                (onChange)="handleVehicleAdsEnabledToggle()">
              </p-toggleswitch>
            </div>
          </div>
        </p-header>
        <!--        TODO: this should use an async pipe instead of null to determine when vehicle ads is enabled (same above for switch)-->
        @if (accountAdTypes !== null && accountAdTypes.vehicleAdType.enabled) {
          <div class="form-body-wrapper">
            @if (businessCategoryConfigurations !== null && masterFormGroup !== null) {
              <form [formGroup]="masterFormGroup" autoTrackUnsavedChanges
                >
                <div class="ad-types-save-button">
                  <span [pTooltip]="getDisabledToolTip()"
                    tooltipPosition="top">
                    <button pButton
                      id="vehicleAdSaveButton"
                      class="p-button-success"
                      label="Save"
                      (click)="handleVehicleAdsSave()"
                      [disabled]="isSaveDisabled">
                    </button>
                  </span>
                </div>
                <p-tabs [value]="0">
                  <p-tablist>
                    <p-tab [value]="0">New</p-tab>
                    <p-tab [value]="1">Used</p-tab>
                  </p-tablist>
                  <p-tabpanels>
                    <p-tabpanel [value]="0">
                      <p-accordion [multiple]="true">
                        <p-accordion-panel value="0">
                          <p-accordion-header class="p-accordionheader">Incentives</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['incentiveConfiguration']">
                              <div class="p-field p-grid">
                                <label for="useIncentiveServiceNew" class="p-col-12 p-md-6 ng-star-inserted">Use Incentive
                                  Service
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When enabled, the best available incentives are pulled from a service during New ad creation."
                                     tooltipPosition="right"></i>
                                </label>
                                <p-toggleswitch
                                  id="useIncentiveServiceNew"
                                  formControlName="useIncentiveService"
                                  (onChange)="setIncentiveControlsStatus()">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="enhancedIncentives" class="p-col-12 p-md-6 ng-star-inserted sub-label">Enhanced Incentives
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When enabled, incentives and MPOP Vehicle Ad sale end dates will be automatically kept up-to-date. This feature requires that the Use Incentive Service feature is enabled."
                                     tooltipPosition="right"></i>
                                </label>
                                <p-toggleswitch
                                  id="enhancedIncentives"
                                  formControlName="enhancedIncentives"
                                  (onChange)="handleEnhancedIncentivesToggle()">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="includeSelectInventoryIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted sub-label">Use VIN Specific Incentives
                                </label>
                                <p-toggleswitch
                                  id="useVinSpecificIncentivesNew"
                                  formControlName="useVinSpecificIncentives">
                                </p-toggleswitch>
                              </div>
                            </form>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['generalConfiguration']">
                              <div class="p-field p-grid">
                                <label for="includeSelectInventoryIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted sub-label">Include
                                  Select Inventory Incentives
                                </label>
                                <p-toggleswitch
                                  id="includeSelectInventoryIncentivesNew"
                                  formControlName="includeSelectInventoryIncentives">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="rebateDisclosureFormatNew" class="p-col-12 p-md-6 ng-star-inserted">Rebate
                                  Disclosure
                                  Format
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="rebateDisclosureFormatNew"
                                    [options]="rebateDisclosureFormatOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="rebateDisclosureFormat">
                                  </p-select>
                                </div>
                              </div>
                              @if (displayConditionalIncentivesAsAvailable) {
                                <div class="p-field p-grid">
                                  <label for="availableOffersLabelNew" class="p-col-12 p-md-6 ng-star-inserted">Conditional Offers Label
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="The label displayed above the Conditional Offers section. This section lists purchase incentives configured as ‘Display as Condtional’ that are excluded from pricing calculations."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <div class="p-col-12 p-md-6">
                                    <input
                                      type="text"
                                      pInputText
                                      id="availableOffersLabelNew"
                                      formControlName="availableOffersLabel"
                                      [ngClass]="{'p-invalid': masterFormGroup.controls['New']['controls']['generalConfiguration'].controls.availableOffersLabel.invalid && masterFormGroup.controls['New']['controls']['generalConfiguration'].controls.availableOffersLabel.touched}">
                                    @if (masterFormGroup.controls['New']['controls']['generalConfiguration'].controls.availableOffersLabel.invalid && masterFormGroup.controls['New']['controls']['generalConfiguration'].controls.availableOffersLabel.touched) {
                                      <small class="p-error">
                                        Label is required and must be 100 characters or less.
                                      </small>
                                    }
                                  </div>
                                </div>
                              }
                              <auto-conditional-incentive-configurator
                                [accountId]="accountId"
                                [conditionalIncentiveFeatureFlagEnabled]="conditionalIncentiveFeatureFlagEnabled"
                                [applicationValues]="applicationValues"
                                (formDirty)="handleConditionalIncentiveFormDirty($event)"
                                (formValid)="setConditionalIncentiveFormValid($event)">
                              </auto-conditional-incentive-configurator>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <auto-offer-rules
                          [accountId]="accountId"
                          [condition]="'New'"
                          (formDirty)="handleOfferRulesFormDirty($event)"
                          (deleteRules)="handleDeleteOfferRules()">
                        </auto-offer-rules>
                        <p-accordion-panel value="2">
                          <p-accordion-header>Fees</p-accordion-header>
                          <p-accordion-content>
                            @if (dynamicFeesTableEnabled) {
                              <div [formGroup]="masterFormGroup.controls['New']['controls']['feesConfiguration']">
                                <auto-dynamic-fees-table
                                  [feesConfigurationFormGroup]="masterFormGroup.controls['New']['controls']['feesConfiguration']"
                                  [categoryName]="'New'">
                                </auto-dynamic-fees-table>
                                <div class="dynamic-fees-final-price-section">
                                  <div class="p-field p-grid">
                                    <label for="dynamic-final-price-text-new" class="p-col-12 p-md-4">Final Price Text</label>
                                    <div class="p-col-12 p-md-8">
                                      <input
                                        type="text"
                                        pInputText
                                        formControlName="finalPriceText"
                                        id="dynamic-final-price-text-new">
                                      <small class="setting-helper-text dynamic-fees-final-price-section__helper">Label displayed for the final total in the mathbox.</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (!dynamicFeesTableEnabled) {
                            <div class="p-d-flex">
                              <form
                                [formGroup]="masterFormGroup.controls['New']['controls']['feesConfiguration']">
                                <table class="p-datatable">
                                  <thead class="p-datatable-thead">
                                  <tr class="p-datatable-header">
                                    <th class="p-mr-2">
                                      Fee
                                    </th>
                                    <th class="p-mr-2">
                                      Value
                                    </th>
                                    <th class="p-mr-2 fee-table-column">
                                      Lease
                                    </th>
                                    <th class="p-mr-2 fee-table-column">
                                      Finance
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody class="p-datatable-tbody">
                                  <tr formGroupName="documentFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'documentFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'documentFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="licenseFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'licenseFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'licenseFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="titleFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'titleFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'titleFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="acquisitionFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'acquisitionFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'acquisitionFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="taxes" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'taxes') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'taxes')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="dispositionFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'dispositionFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'dispositionFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                <h4 class="form-section-sub-header">Purchase Fee</h4>
                                <div formGroupName="customFee">
                                  <div class="p-field p-grid">
                                    <label for="custom-fee-enabled-new" class="p-col-12 p-md-6 ng-star-inserted">Custom Purchase
                                      Fee
                                      <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                         pTooltip="When enabled, this custom purchase fee will be applied in the math box for all new ads. The mathbox will reflect a final price including applicable purchase rebates and this fee."
                                         tooltipPosition="right"></i>
                                    </label>
                                    <p-toggleswitch
                                      formControlName="enabled"
                                      id="custom-fee-enabled-new"
                                    ></p-toggleswitch>
                                <span class="setting-helper-text">When Shared Offer Sets are enabled, purchase fee configurations must remain consistent across linked accounts.</span>
                                  </div>
                                  <div class="p-grid purchase-fee-grid">
                                    <div class="p-col-6">
                                      <label for="display-name-new">Display Name</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="displayName" id="display-name-new">
                                    </div>
                                    <div class="p-col-6">
                                      <label for="value-new">Value ($)</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="value" id="value-new">
                                    </div>
                                    <div class="p-col-6">
                                      <label for="pricing-option-new">Pricing Option
                                        <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                           pTooltip="Select how the purchase fee should be handled in the sale price:
Add Purchase Fee to Sale Price – The purchase fee will be added to the sale price in the ad and reflected in the final price. The fee will also be itemized separately in the Math Box.
Purchase Fee is Included in Sale Price – The purchase fee is part of the price received from inventory. The displayed sale price in the offer will be reduced by the fee amount, which will then be itemized separately in the Math Box. This reduced price will also be used for lease and finance calculations."
                                           tooltipPosition="right"></i></label>
                                    </div>
                                    <div class="p-col-6">
                                      <p-select
                                        [options]="pricingOptions"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="pricingOption"
                                        id="pricing-option-new">
                                      </p-select>
                                    </div>
                                    <div class="p-col-6">
                                      <label for="final-price-text-new">Final Price Text</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="finalPriceText" id="final-price-text-new">
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                            }
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="3">
                          <p-accordion-header>Purchase & Savings Offers</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['purchaseConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showPurchaseOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Purchase Offers
                                </label>
                                <p-toggleswitch
                                  id="showPurchaseOfferNew"
                                  formControlName="showPurchaseOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="showMathBoxNew" class="p-col-12 p-md-6 ng-star-inserted">Show Math Box
                                </label>
                                <p-toggleswitch
                                  id="showMathBoxNew"
                                  formControlName="showMathBox">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="showSavingsOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Savings Offers
                                </label>
                                <p-toggleswitch
                                  id="showSavingsOfferNew"
                                  formControlName="showSavingsOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="showPreRebateSubtotalNew" class="p-col-12 p-md-6 ng-star-inserted">Show Pre-Rebate
                                  Subtotal
                                </label>
                                <p-toggleswitch
                                  id="showPreRebateSubtotalNew"
                                  formControlName="showPreRebateSubtotal">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="showLineItemSuperscriptsNew" class="p-col-12 p-md-6 ng-star-inserted">Show Line Item
                                  Superscripts
                                </label>
                                <p-toggleswitch
                                  id="showLineItemSuperscriptsNew"
                                  formControlName="showLineItemSuperscripts">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="includePurchaseDealerIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted">Include
                                  Dealer Incentives
                                </label>
                                <p-toggleswitch
                                  id="includePurchaseDealerIncentivesNew"
                                  formControlName="includePurchaseDealerIncentives">
                                </p-toggleswitch>
                              </div>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="4">
                          <p-accordion-header>Lease Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['leaseConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showLeaseOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Lease Offers
                                </label>
                                <p-toggleswitch
                                  id="showLeaseOfferNew"
                                  formControlName="showLeaseOffer">
                                </p-toggleswitch>
                              </div>
                              @if (hideLeaseOfferWithDealerAddonEnabled) {
                                <div class="p-field p-grid">
                                  <label for="hideLeaseOfferWithDealerAddonNew" class="p-col-12 p-md-6 ng-star-inserted">Hide Lease with Add-ons
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="When enabled, Lease Offers will be hidden if a Dealer Add-on is present in the Offer Set."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <p-toggleswitch
                                    id="hideLeaseOfferWithDealerAddonNew"
                                    formControlName="hideLeaseOfferWithDealerAddon">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="showAlternateLeaseOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Alternate
                                  Lease Offers
                                </label>
                                <p-toggleswitch
                                  id="showAlternateLeaseOfferNew"
                                  formControlName="showAlternateLeaseOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="leaseSellingPriceTypeNew" class="p-col-12 p-md-6 ng-star-inserted">Selling Price
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="leaseSellingPriceTypeNew"
                                    [options]="leaseSellingPriceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leaseSellingPriceType">
                                  </p-select>
                                </div>
                              </div>
                              <div class="p-field p-grid">
                                <div class="p-col-6">
                                  <div class="p-field p-grid purchase-fee-grid">
                                    <div class="p-col-12 p-md-6">
                                      <p-select
                                        id="calculateLeaseFrom"
                                        [options]="calculateLeaseFromOptions"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="calculateLeaseFrom">
                                      </p-select>
                                    </div>
                                    <div class="p-col-6">
                                      <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                         pTooltip="Adjusting this setting will change the lease payment calculation method.

                                 A lease 'down payment' is a portion of the vehicle's cost paid upfront and reduces monthly lease payments. 'Due at signing' is the total amount due at the time of signing and includes the down payment, first month's payment, plus any fees required to start the lease."
                                         tooltipPosition="right"></i>
                                    </div>
                                  </div>
                                </div>
                                <div class="p-col-2">
                                  <input pInputText
                                         id="leaseDownDueAmount"
                                         formControlName="leaseDownDueAmount"
                                         type="number"
                                         step="0.001"
                                         class="lease-down-due-wrapper"
                                  />
                                </div>
                                <div class="p-col-12 p-md-1">
                                  <p-select
                                    id="leasePaymentType"
                                    [options]="leasePaymentTypeOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leasePaymentType">
                                  </p-select>
                                </div>
                                @if (leasePaymentTypeControl.value === 'percent') {
                                  <div class="p-col-12 p-md-3">
                                    <div class="lease-pricing-base-wrapper purchase-fee-grid">
                                      <div class="p-col-2">
                                        <label for="leasePricingBase">of
                                        </label>
                                      </div>
                                      <div class="p-col-10">
                                        <p-select
                                          id="leasePricingBase"
                                          [options]="leasePricingBaseOptions"
                                          optionLabel="label"
                                          optionValue="value"
                                          formControlName="leasePricingBase">
                                        </p-select>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                              <div class="p-field p-grid">
                                <label for="includeLeaseDealerIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted">Include
                                  Dealer
                                  Incentives
                                </label>
                                <p-toggleswitch
                                  id="includeLeaseDealerIncentivesNew"
                                  formControlName="includeLeaseDealerIncentives">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="leaseIncentiveTypeNew" class="p-col-12 p-md-6 ng-star-inserted">Lease Incentive
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="leaseIncentiveTypeNew"
                                    [options]="leaseIncentiveTypeOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leaseIncentiveType">
                                  </p-select>
                                </div>
                              </div>
                              <div class="p-grid purchase-fee-grid">
                                <div class="p-col-6">
                                  <label for="moneyFactorMarkupNew">Money Factor Markup
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="The markup is added to the best rate from the Incentive Service. Lease APR/2400 converts percentage value to money factor."
                                       tooltipPosition="right"></i>
                                  </label>
                                </div>
                                <div class="p-col-6">
                                  <input pInputText
                                         id="moneyFactorMarkupNew"
                                         formControlName="moneyFactorMarkup"
                                         type="number"
                                         step="0.01"
                                  />
                                </div>
                                @if (newMoneyFactorMarkupControl.invalid) {
                                  <span                              class="p-invalid p-col-12 p-md-6 ng-star-inserted">
                            Money Factor Markup must be a decimal value less than 1.
                          </span>
                                }
                              </div>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="5">
                          <p-accordion-header>Finance Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['financeConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showFinanceOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Finance Offers
                                </label>
                                <p-toggleswitch
                                  id="showFinanceOfferNew"
                                  formControlName="showFinanceOffer">
                                </p-toggleswitch>
                              </div>
                              @if (hideFinanceOfferWithDealerAddonEnabled) {
                                <div class="p-field p-grid">
                                  <label for="hideFinanceOfferWithDealerAddonNew" class="p-col-12 p-md-6 ng-star-inserted">Hide Finance with Add-ons
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="When enabled, Finance Offers will be hidden if a Dealer Add-on is present in the Offer Set."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <p-toggleswitch
                                    id="hideFinanceOfferWithDealerAddonNew"
                                    formControlName="hideFinanceOfferWithDealerAddon">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="financeAprSourceNew" class="p-col-12 p-md-6 ng-star-inserted">Finance APR Source
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When Incentive Service is selected, the Finance APR with the longest term is pulled from the Real-Time Incentive Service. When Account Defaults is selected, the Finance APR will come from the defaults configured for the account."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="financeAprSourceNew"
                                    [options]="financeAprSourceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="financeAprSource">
                                  </p-select>
                                </div>
                              </div>
                              <div class="p-field p-grid">
                                <label for="downPaymentBasedOnNew" class="p-col-12 p-md-6 ng-star-inserted">Down Payment Based On
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="Determines whether the down payment is calculated using the vehicle’s MSRP or the Buy Price."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                <p-select
                                  id="downPaymentBasedOnNew"
                                  [options]="downPaymentBasedOnOptions"
                                  optionLabel="label"
                                  optionValue="value"
                                  formControlName="downPaymentBasedOn">
                                </p-select>
                                </div>
                              </div>
                              <div class="p-field p-grid">
                                <label for="includeFinanceDealerIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted">Include
                                  Dealer Incentives
                                </label>
                                <p-toggleswitch
                                  id="includeFinanceDealerIncentivesNew"
                                  formControlName="includeFinanceDealerIncentives">
                                </p-toggleswitch>
                              </div>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="6">
                          <p-accordion-header>APR Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['aprConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showAprOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show APR Offers
                                </label>
                                <p-toggleswitch
                                  id="showAprOfferNew"
                                  formControlName="showAprOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="useChromeIncentivesAprOfferNew" class="p-col-12 p-md-6 ng-star-inserted"> APR Source
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When using the Incentive Service, the lowest available Finance APR with the longest correlating term is applied. When no APR is found, the Account Default is used as a fallback if available."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="useChromeIncentivesAprOfferNew"
                                    [options]="aprSourceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="useChromeIncentivesAprOffer">
                                  </p-select>
                                </div>
                              </div>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                      </p-accordion>
                    </p-tabpanel>
                    <p-tabpanel [value]="1">
                      <p-accordion [multiple]="true">
                        <auto-offer-rules
                          [accountId]="accountId"
                          [condition]="'Used'"
                          (formDirty)="handleOfferRulesFormDirty($event)"
                          (deleteRules)="handleDeleteOfferRules()">
                        </auto-offer-rules>
                        <p-accordion-panel value="2">
                          <p-accordion-header>Fees</p-accordion-header>
                          <p-accordion-content>
                            @if (dynamicFeesTableEnabled) {
                              <div [formGroup]="masterFormGroup.controls['Used']['controls']['feesConfiguration']">
                                <auto-dynamic-fees-table
                                  [feesConfigurationFormGroup]="masterFormGroup.controls['Used']['controls']['feesConfiguration']"
                                  [categoryName]="'Used'">
                                </auto-dynamic-fees-table>
                                <div class="dynamic-fees-final-price-section">
                                  <div class="p-field p-grid">
                                    <label for="dynamic-final-price-text-used" class="p-col-12 p-md-4">Final Price Text</label>
                                    <div class="p-col-12 p-md-8">
                                      <input
                                        type="text"
                                        pInputText
                                        formControlName="finalPriceText"
                                        id="dynamic-final-price-text-used">
                                      <small class="setting-helper-text dynamic-fees-final-price-section__helper">This label is shared across all purchase fee rows.</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (!dynamicFeesTableEnabled) {
                            <div class="p-d-flex">
                              <form
                                [formGroup]="masterFormGroup.controls['Used']['controls']['feesConfiguration']">
                                <table class="p-datatable">
                                  <thead class="p-datatable-thead">
                                  <tr class="p-datatable-header">
                                    <th class="p-mr-2">
                                      Fee
                                    </th>
                                    <th class="p-mr-2">
                                      Value
                                    </th>
                                    <th class="p-mr-2 fee-table-column">
                                      Lease
                                    </th>
                                    <th class="p-mr-2 fee-table-column">
                                      Finance
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody class="p-datatable-tbody">
                                  <tr formGroupName="documentFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'documentFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'documentFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="licenseFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'licenseFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'licenseFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="titleFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'titleFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'titleFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="acquisitionFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'acquisitionFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'acquisitionFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="taxes" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'taxes') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'taxes')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="dispositionFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'dispositionFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'dispositionFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                <h4 class="form-section-sub-header">Purchase Fee</h4>
                                <div formGroupName="customFee">
                                  <div class="p-field p-grid">
                                    <label for="custom-fee-enabled-used" class="p-col-12 p-md-6 ng-star-inserted">Custom
                                      Purchase
                                      Fee
                                      <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                         pTooltip="When enabled, this custom purchase fee will be applied in the math box for all used ads. The mathbox will reflect a final price including applicable purchase rebates and this fee."
                                         tooltipPosition="right"></i>
                                    </label>
                                    <p-toggleswitch
                                      formControlName="enabled"
                                      id="custom-fee-enabled-used"
                                    ></p-toggleswitch>
                                <span class="setting-helper-text">When Shared Offer Sets are enabled, purchase fee configurations must remain consistent across linked accounts.</span>
                                  </div>
                                  <div class="p-grid purchase-fee-grid">
                                    <div class="p-col-6">
                                      <label for="display-name-used">Display Name</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="displayName" id="display-name-used">
                                    </div>
                                    <div class="p-col-6">
                                      <label for="value-used">Value ($)</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="value" id="value-used">
                                    </div>
                                    <div class="p-col-6">
                                      <label for="pricing-option-existing">Pricing Option
                                        <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                           pTooltip="Select how the purchase fee should be handled in the sale price:
Add Purchase Fee to Sale Price – The purchase fee will be added to the sale price in the ad and reflected in the final price. The fee will also be itemized separately in the Math Box.
Purchase Fee is Included in Sale Price – The purchase fee is part of the price received from inventory. The displayed sale price in the offer will be reduced by the fee amount, which will then be itemized separately in the Math Box. This reduced price will also be used for lease and finance calculations."
                                           tooltipPosition="right"></i></label>
                                    </div>
                                    <div class="p-col-6">
                                      <p-select
                                        [options]="pricingOptions"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="pricingOption"
                                        id="pricing-option-existing">
                                      </p-select>
                                    </div>
                                    <div class="p-col-6">
                                      <label for="final-price-text-used">Final Price Text</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="finalPriceText" id="final-price-text-used">
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                            }
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="3">
                          <p-accordion-header>Purchase & Savings Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['Used']['controls']['purchaseConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showPurchaseOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Purchase Offers
                                </label>
                                <p-toggleswitch
                                  id="showPurchaseOfferUsed"
                                  formControlName="showPurchaseOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="showSavingsOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Savings Offers
                                </label>
                                <p-toggleswitch
                                  id="showSavingsOfferUsed"
                                  formControlName="showSavingsOffer">
                                </p-toggleswitch>
                              </div>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="4">
                          <p-accordion-header>Lease Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['Used']['controls']['leaseConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showLeaseOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Lease Offers
                                </label>
                                <p-toggleswitch
                                  id="showLeaseOfferUsed"
                                  formControlName="showLeaseOffer">
                                </p-toggleswitch>
                              </div>
                              @if (hideLeaseOfferWithDealerAddonEnabled) {
                                <div class="p-field p-grid">
                                  <label for="hideLeaseOfferWithDealerAddonUsed" class="p-col-12 p-md-6 ng-star-inserted">Hide Lease with Add-ons
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="When enabled, Lease Offers will be hidden if a Dealer Add-on is present in the Offer Set."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <p-toggleswitch
                                    id="hideLeaseOfferWithDealerAddonUsed"
                                    formControlName="hideLeaseOfferWithDealerAddon">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="showAlternateLeaseOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Alternate
                                  Lease Offers
                                </label>
                                <p-toggleswitch
                                  id="showAlternateLeaseOfferUsed"
                                  formControlName="showAlternateLeaseOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="leaseSellingPriceTypeUsed" class="p-col-12 p-md-6 ng-star-inserted">Selling Price
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="leaseSellingPriceTypeUsed"
                                    [options]="leaseSellingPriceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leaseSellingPriceType">
                                  </p-select>
                                </div>
                              </div>
                              <div class="p-field p-grid">
                                <label for="leaseIncentiveTypeUsed" class="p-col-12 p-md-6 ng-star-inserted">Lease Incentive
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="leaseIncentiveTypeUsed"
                                    [options]="leaseIncentiveTypeOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leaseIncentiveType">
                                  </p-select>
                                </div>
                              </div>
                              <div class="p-grid purchase-fee-grid">
                                <div class="p-col-6">
                                  <label for="moneyFactorMarkupUsed">Money Factor Markup
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="The markup is added to the best rate from the Incentive Service. Lease APR/2400 converts percentage value to money factor."
                                       tooltipPosition="right"></i>
                                  </label>
                                </div>
                                <div class="p-col-6">
                                  <input pInputText
                                         id="moneyFactorMarkupUsed"
                                         formControlName="moneyFactorMarkup"
                                         type="number"
                                         step="0.01"
                                  />
                                </div>
                                @if (usedMoneyFactorMarkupControl.invalid) {
                                  <span                              class="p-invalid p-col-12 p-md-6 ng-star-inserted">
                Money Factor Markup must be a decimal value less than 1.
              </span>
                                }
                              </div>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="5">
                          <p-accordion-header>Finance Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['Used']['controls']['financeConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showFinanceOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Finance Offers
                                </label>
                                <p-toggleswitch
                                  id="showFinanceOfferUsed"
                                  formControlName="showFinanceOffer">
                                </p-toggleswitch>
                              </div>
                              @if (hideFinanceOfferWithDealerAddonEnabled) {
                                <div class="p-field p-grid">
                                  <label for="hideFinanceOfferWithDealerAddonUsed" class="p-col-12 p-md-6 ng-star-inserted">Hide Finance with Add-ons
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="When enabled, Finance Offers will be hidden if a Dealer Add-on is present in the Offer Set."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <p-toggleswitch
                                    id="hideFinanceOfferWithDealerAddonUsed"
                                    formControlName="hideFinanceOfferWithDealerAddon">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="financeAprSourceUsed" class="p-col-12 p-md-6 ng-star-inserted">Finance APR Source
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When Incentive Service is selected, the Finance APR with the longest term is pulled from the Real-Time Incentive Service. When Account Defaults is selected, the Finance APR will come from the defaults configured for the account."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="financeAprSourceUsed"
                                    [options]="usedFinanceAprSourceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="financeAprSource">
                                  </p-select>
                                </div>
                              </div>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="6">
                          <p-accordion-header>APR Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['Used']['controls']['aprConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showAprOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show APR Offers
                                </label>
                                <p-toggleswitch
                                  id="showAprOfferUsed"
                                  formControlName="showAprOffer">
                                </p-toggleswitch>
                              </div>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                      </p-accordion>
                    </p-tabpanel>
                  </p-tabpanels>
                </p-tabs>
              </form>
              <div class="modal-button-wrapper">
                <p-confirmDialog
                  key="documentFeeWarning"
                  [style]="{ width: '32rem' }"
                  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"></p-confirmDialog>
              </div>
            }
          </div>
        }
      </p-panel>
<p-panel class="ad-types-form-panel" [collapsed]="promotionalAdTypesCollapsed"
  [toggleable]="accountAdTypes !== null && accountAdTypes.promotionalAdType.enabled">
  <p-header class="ad-types-header-wrapper form-panel-header">
    <h3 class="ad-types-header-text">Promotional Ads</h3>
    <p class="coming-soon-header">Coming Soon! <i class="pi pi-clock"></i></p>
    <div class="ad-types-header-input">
      <div class="ad-types-header-input">
        <p-toggleswitch
          [ngModel]="accountAdTypes !== null && accountAdTypes.promotionalAdType.enabled" (ngModelChange)="accountAdTypes !== null && (accountAdTypes.promotionalAdType.enabled = $event)"
          (onChange)="handlePromotionalAdsEnabledToggle()">
        </p-toggleswitch>
      </div>
    </div>
  </p-header>
  @if (accountAdTypes !== null && accountAdTypes.promotionalAdType.enabled) {
    <div class="form-body-wrapper">
      <div class="ad-types-save-button">
        <button pButton
          class="p-button-success"
          label="Save"
          (click)="handlePromotionalAdsSave()"
          [disabled]="!promotionalAdMasterFormGroup.valid">
        </button>
      </div>
      <p-tabs
        class="business-category-tabs"
        [(value)]="promotionalActiveTabValue">
        <p-tablist>
          @for (tab of promotionalAdTabs; track tab) {
            <p-tab [value]="tab.id">{{ tab.label }}</p-tab>
          }
        </p-tablist>
      </p-tabs>
      @if (promotionalAdsConfigurations) {
        <form [formGroup]="promotionalAdMasterFormGroup" autoTrackUnsavedChanges>
          <div class="p-fluid">
            <h4 class="form-section-header">General</h4>
            <div class="p-field p-grid">
              <label for="promotion-categories" class="p-col">Promotion Categories</label>
              <div class="p-col">
                <p-multiSelect id="promotion-categories"
                  [options]="accountServiceCategories"
                  formControlName="subcategories"
                  optionLabel="name"
                  dataKey="id"
                  placeholder="Sub-Category"
                  filterPlaceHolder="Select All"
                  resetFilterOnHide="true">
                </p-multiSelect>
              </div>
            </div>
            <div class="p-field p-grid">
              <label for="disclosure-addon" class="p-col">Disclosure Add-on</label>
              <div class="p-col">
                <textarea id="disclosure-addon"
                  formControlName="disclosureAddon"
                  [rows]="5"
                  [cols]="60"
                  pInputTextarea
                  autoResize="autoResize">
                </textarea>
              </div>
            </div>
          </div>
          <div>
            <div>
              <h4 class="form-section-header">Calls to Action</h4>
              <div formArrayName="callsToAction" class="call-to-action-boundary">
                <div class="call-to-action-list p-grid" cdkDropList (cdkDropListDropped)="callToActionDrop($event)">
                  @for (callToAction of this.callsToAction.controls; track callToAction; let i = $index) {
                    <div cdkDrag
                      class="p-col-fixed" cdkDragBoundary=".call-to-action-boundary" style="width:100%">
                      <p-card [formGroupName]="i">
                        <div class="p-grid">
                          <div cdkDragHandle class="p-col-fixed cta-handle" style="width:50px;">
                            <i class="pi pi-bars"></i>
                          </div>
                          <div class="p-col p-grid">
                            <div class="p-col-fixed" style="width:100%">
                              <input pInputText
                                aria-label="Call to action text"
                                class="call-to-action-text"
                                formControlName="callToActionText"
                                placeholder="Text displayed for CTA"
                                [ngClass]="{'p-invalid': callToAction.get('callToActionText').hasError('alphanumeric') || callToAction.get('callToActionText').hasError('required')}"
                                />
                              @if (callToAction.get('callToActionText').hasError('required')) {
                                <span
                                  class="p-invalid">
                                  CTA display text is required.
                                </span>
                              }
                            </div>
                            <div class="p-col-fixed" style="width:100%">
                              <p-select class="action-type"
                                aria-label="Action Type"
                                [options]="actionOptions | async"
                                formControlName="actionOptions"
                                dataKey="value"
                                optionLabel="label"
                                placeholder="Action"
                                [ngClass]="{'p-invalid': callToAction.get('actionOptions').hasError('emptyDropdownSelection')}">
                              </p-select>
                              @if (callToAction.get('actionOptions').hasError('emptyDropdownSelection')) {
                                <span
                                  class="p-invalid">
                                  Action type is required.
                                </span>
                              }
                            </div>
                            <div class="p-col-fixed" style="width:46%">
                              <input pInputText
                                aria-label="URL"
                                class="url"
                                placeholder="Custom destination URL"
                                formControlName="actionUrl"/>
                            </div>
                            <div class="p-col-fixed" style="width:46%">
                              <p-select class="target-selection"
                                aria-label="Target Selection"
                                [options]="targetOptions"
                                formControlName="target"
                                dataKey="value"
                                optionLabel="label"
                                placeholder="Target"
                                [ngClass]="{'p-invalid': callToAction.get('target').hasError('emptyDropdownSelection')}">
                              </p-select>
                              @if (callToAction.get('target').hasError('emptyDropdownSelection')) {
                                <span
                                  class="p-invalid">
                                  Target is required.
                                </span>
                              }
                            </div>
                            <div class="p-col trash-icon">
                              <i class="pi pi-trash" (click)="deleteCallToAction(i)"></i>
                            </div>
                          </div>
                        </div>
                      </p-card>
                    </div>
                  }
                </div>
              </div>
              <div class="add-cta-button">
                <button pButton type="button" icon="pi pi-plus" (click)="addNewCallToAction()"></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  }
</p-panel>
</p-panel>
</div>
</p-panel>
<auto-footer></auto-footer>
